import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './ToolPage.css'
import './BingoRoom.css'
import { createBingoRoom } from './utils/bingoApiClient'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const WIN_CONDITIONS = [
  { key: 'full_card', label: 'Cartela cheia' },
  { key: 'line', label: 'Linha (horizontal)' },
  { key: 'column', label: 'Coluna (vertical)' },
  { key: 'diagonal', label: 'Diagonal' },
]

const BingoRoomCreate = () => {
  useDocumentMeta({
    title: 'Bingo ao Vivo em Sala | jarder.dev',
    description:
      'Crie uma sala de bingo, sorteie os números e veja ao vivo quem ' +
      'está perto de ganhar. Cada participante entra pelo link e recebe ' +
      'a cartela automaticamente, sem precisar marcar nada.',
  })

  const history = useHistory()
  const [winConditions, setWinConditions] = useState(['full_card'])
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState('')

  const toggleCondition = (key) => {
    setWinConditions((current) =>
      current.includes(key) ? current.filter((item) => item !== key) : [...current, key],
    )
  }

  const create = async () => {
    setStatus('loading')
    setError('')
    try {
      const { id, masterToken } = await createBingoRoom(winConditions)
      trackEvent('tool_generate', { tool: 'bingo_room', winConditions: winConditions.join(',') })
      history.push(`/ferramentas/bingo-ao-vivo/${id}/mestre#token=${masterToken}`)
    } catch {
      setError('Não foi possível criar a sala agora. Tente novamente.')
      setStatus('idle')
    }
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Bingo ao Vivo em Sala</h1>
      <p className="tool-disclaimer">
        Você sorteia os números como mestre da sala (ou marca o número
        que saiu no seu sorteador físico); cada participante entra pelo
        link, recebe uma cartela automaticamente e não precisa marcar
        nada: a cartela se atualiza sozinha.
      </p>

      <fieldset className="tool-field bingo-win-conditions-field">
        <legend>Como um ganhador é definido? (marque uma ou mais)</legend>
        <div className="bingo-win-conditions">
          {WIN_CONDITIONS.map((option) => (
            <label key={option.key} className="bingo-win-condition-option">
              <input
                type="checkbox"
                checked={winConditions.includes(option.key)}
                onChange={() => toggleCondition(option.key)}
              />
              {option.label}
            </label>
          ))}
        </div>
        {winConditions.length > 1 && (
          <p className="tool-import-hint">
            Quem completar qualquer uma dessas condições primeiro ganha.
          </p>
        )}
      </fieldset>

      <button
        type="button"
        className="tool-button"
        onClick={create}
        disabled={status === 'loading' || winConditions.length === 0}
      >
        {status === 'loading' ? 'Criando sala...' : 'Criar sala de bingo'}
      </button>

      {error && <p className="tool-error">{error}</p>}

      <div className="tool-info-section">
        <h2>Como funciona</h2>
        <p>
          Ao criar, você vai pra tela de mestre, só você tem acesso a
          ela. Lá tem um link separado pra compartilhar com os
          participantes: cada um que entrar recebe uma cartela única.
        </p>
        <p>
          Você pode sortear um número aleatório pelo próprio site, ou
          usar um sorteador físico e clicar no número correspondente na
          tela: os dois jeitos funcionam juntos.
        </p>
        <p>
          Conforme os números vão sendo marcados, todas as cartelas são
          atualizadas automaticamente, e você vê em tempo real quem está
          mais perto de ganhar segundo a condição escolhida.
        </p>
      </div>
    </div>
  )
}

export default BingoRoomCreate
